import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import { Switch, NavLink, Route } from "react-router-dom";
import SettingsIcon from "@mui/icons-material/Settings";
import CalendarIcon from "@mui/icons-material/CalendarMonth";

import { hesLogo } from "../images/hesLogo";

function MobileNav({ toggleDrawer, user, signOutGoogle }) {
  // const isActive = (match, location) => {
  //   if (match) return true;

  //   if (location.pathname.includes(navLink.matcher)) return true;

  //   return false;
  // }
  return (
    <nav onClick={toggleDrawer(false)} className="sidebarNav">
      <div className="sideHeader">
        {/* <img alt="Henderson Electrical Services" src={hesLogo} /> */}
        <p>{user.email}</p>
      </div>
      <span className="splitter"></span>
      <NavLink activeClassName="activeLink" to="/">
        {/* <TitleIcon style={{ fontSize: 28 }} /> */}
        <span className={`${"sideIcon"} ${"sideLetter"}`}>T</span>
        Timesheets
      </NavLink>
      <NavLink activeClassName="activeLink" to="/quotes">
        <span className={`${"sideIcon"} ${"sideLetter"}`}>Q</span>
        Quotes
      </NavLink>
      <NavLink activeClassName="activeLink" to="/jobsheets">
        <span className={`${"sideIcon"} ${"sideLetter"}`}>J</span>
        Jobsheets
      </NavLink>
      <NavLink activeClassName="activeLink" to="/restores">
        <span className={`${"sideIcon"} ${"sideLetter"}`}>R</span>
        Restore
      </NavLink>
      <NavLink activeClassName="activeLink" to="/calendar">
        <CalendarIcon className="sideIcon" />
        Calendar
      </NavLink>
      <span className="splitter"></span>
      <NavLink activeClassName="activeLink" to="/settings">
        <SettingsIcon className="sideIcon" />
        Settings
      </NavLink>

      {/* <NavLink activeClassName="activeLink" to="/export">
        <ImportExportIcon className="sideIcon" />
        Export
      </NavLink> */}
      <span className="splitter"></span>
      <span tabIndex={0} className="signOut">
        <ExitToAppIcon className="sideIcon" />
        <button onClick={signOutGoogle}>Sign Out</button>
      </span>
    </nav>
  );
}

export default MobileNav;
